import { css } from '@emotion/react';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/react';
import React from 'react';
import * as commonCss from '../../styles/common';
import PoweredBy from '../PoweredBy';

const learnMoreCss = {
  container: [
    [
      commonCss.centered,
      commonCss.smallText,
      css({
        backgroundColor: 'var(--ion-background-color)',
        borderRadius: 10,
      }),
    ],
  ],
  col: [css({ alignSelf: 'center' })],
};

export const LearnMoreBox: React.FC = () => {
  return (
    <div css={learnMoreCss.container}>
      <IonGrid>
        <IonRow>
          <IonCol css={learnMoreCss.col}>
            <PoweredBy sizePixels={120} text="OpenMap is powered by" fontSize={10} />
          </IonCol>
          <IonCol css={learnMoreCss.col}>
            <IonButton href="https://clarity.io">Learn more!</IonButton>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};
